<template>
  <div class="password-container">
      <div class="password-table">
        <div class="password-table-title">重置密码</div>
        <div class="password-table-new"><input type="password" v-model="newPw" placeholder="请输入新密码"></div>
        <div class="password-table-remake"><input type="password" v-model="newPw2" placeholder="请确认新密码"></div>
        <div class="v-table-input-btn"><button @click="forgetPassword">确定</button></div>
      </div>
  </div>
</template>

<script>
  import {ApiForgetPassword} from '../../../net/home/index.js'
  import {checkMobile} from '../../../untils/common.js'
  export default {
    data: function () {
      return {
        newPw: '',
        newPw2: ''
      }
    },
    props: {
      codeCheck: {
        type: String
      }
    },
    methods: {
      checkPw: function () {
        if (!checkMobile(this.newPw)) {
          this.$message({
            message: '新密码格式有误',
            type: 'warning'
          })
          return false
        }

        if (this.newPw != this.newPw2) {
          this.$message({
            message: '两次输入密码不一致',
            type: 'warning'
          })
          return false
        }

        return true
      },
      forgetPassword: function () {
        if (!this.checkPw()) {return}
        const prames = {
          codeCheck: this.$props.codeCheck,
          password: this.newPw
        }
        // console.log('prames', prames)
        ApiForgetPassword(prames).then(res=>{
          if (res.code == 200) {
            this.$message.success('密码重置成功')
            setTimeout(()=>{
              this.$router.push('/')
            }, 2000)
          }
        })
      }
    }
  }
</script>

<style scoped>
  .password-container{
  	width: 1140px;
  	margin: 0 auto;
  	margin-top: 20px;
  	height: 500px;
  	background: #fff;
  	border-radius: 6px;
  }
  .password-table{
  	width: 320px;
  	margin: 0 auto;
  	overflow: hidden;
  }
  .password-table-title{
  	font-size:20px;
  	color: #252525;
  	margin-top: 50px;
  }
  .password-table-new{
  	width: 320px;
  	margin:0 auto;
  	margin-top: 24px;
  }
  .password-table-new input{
  	width: 308px;
  	height: 38px;
  	border: 1px solid #ccc;
  	border-radius: 4px;
  	padding: 5px;
  	outline: none;
  	font-size: 16px;
  }
  .password-table-remake{
  	width: 320px;
  	margin:0 auto;
  	margin-top: 24px;
  }
  .password-table-remake input{
  	width: 308px;
  	height: 38px;
  	border: 1px solid #ccc;
  	border-radius: 4px;
  	padding: 5px;
  	outline: none;
  	font-size: 16px;
  }
  .v-table-input-btn{
  	width: 320px;
  	margin-top: 24px;
  }
  .v-table-input-btn button{
  	width: 320px;
  	height: 48px;
  	border-radius: 4px;
  	background-color: #0AAC50;
  	border: none;
  	color: #fff;
  	font-size: 16px;
  }
  .v-table-input-btn button{
  	width: 320px;
  	height: 48px;
  	border-radius: 4px;
  	background-color: #0AAC50;
  	border: none;
  	color: #fff;
  	font-size: 16px;
  	outline: none;
  	border: 1px solid transparent;
  }
  .v-table-input-btn button:hover{
  	background-color: #019B3C;
  	cursor:pointer;
  	outline: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/ForGetPassword/children/password.vue